import { EnvironmentUtilities } from 'frontend-toolkit';
import ENVIRONMENT from './environment';

const envUtils = new EnvironmentUtilities(window.location.host);

export const IS_PROD = ENVIRONMENT.indexOf('prod') !== -1;

export const NGB_INTEGRATION_CODES = {
  usaHockey: 'usa_hockey',
  usaLacrosse: 'usa_lacrosse',
  hockey_canada: 'hockey_canada'
};

export const ORDERS_URL = {
  local: 'http://localhost:3006',
  test: 'http://localhost:3006',
  staging: `https://${envUtils.getStagingHost('order', 'staging.order.teamsnap.com')}`,
  prod: 'https://order.teamsnap.com',
}[ENVIRONMENT];

export const APP_URL = {
  local: 'http://localhost:3000',
  test: 'http://localhost:3000',
  staging: 'https://staging.registration.teamsnap.com',
  prod: 'https://registration.teamsnap.com',
}[ENVIRONMENT];

export const API_URL = {
  local: 'http://localhost:5602',
  test: 'http://localhost:5602',
  staging: 'https://staging-registration-api-prime.teamsnap.com',
  prod: 'https://registration-api.teamsnap.com',
}[ENVIRONMENT];

export const TEAMSNAP_URL = {
  local: 'http://localhost:3001',
  test: 'http://localhost:3001',
  staging: 'https://pod-sports-org.teamsnap.com',
  prod: 'https://go.teamsnap.com',
}[ENVIRONMENT];

export const STRIPE_CLIENT_KEY = {
  local: 'pk_test_51Dq5BXH3v9ZxQViIRIr5T0mX3fZxXXYszWlkHrurMnaCQq9UWoXw5jaX6OK7QkG9pALgvQ7zL8zNYXQRiVJKalAn00GyEUjvGu',
  staging:
    'pk_test_51Dq5BXH3v9ZxQViIRIr5T0mX3fZxXXYszWlkHrurMnaCQq9UWoXw5jaX6OK7QkG9pALgvQ7zL8zNYXQRiVJKalAn00GyEUjvGu',
  prod: 'pk_live_VOrEglkce2zbFN3dJ6aEmZ1c',
}[ENVIRONMENT];

export const SENTRY_URL = 'https://2ab07085e0054043970872962e9f1f8c@o126035.ingest.sentry.io/4504120004444160';
